import type { HttpClient } from "@/shared/types/HttpClient"
import { createAccessRequestApi } from "./accessRequest"
import { createCustomerApi } from "./customers"
import { createDeploymentApi, getDeploymentStatusApi } from "./deployments"
import { createPlanCustomerApi } from "./planCustomers"
import { createSpiceDbApi } from "./spiceDb"
import type { ICmApi } from "./types"
import { createUiDefinitionsApi } from "./uiDefinitions"
import { createVisualizationApi } from "./visualization"

export const createCmApi = (client: HttpClient): ICmApi => ({
  ...createCustomerApi(client),
  ...createPlanCustomerApi(client),
  ...createUiDefinitionsApi(client),
  ...createVisualizationApi(client),
  ...createAccessRequestApi(client),
  ...createSpiceDbApi(client),
  ...createDeploymentApi(client),
  ...getDeploymentStatusApi(client)
})
